// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ui.table[data-v-1c34f39a]{background:transparent}.ui.table>thead>tr>th[data-v-1c34f39a]{color:grey}.ui.image.header>.content[data-v-1c34f39a]{font-size:14px;font-weight:400}.nonOnlineRow[data-v-1c34f39a]{color:grey}.nonOnlineRow[data-v-1c34f39a]:hover{color:grey!important}.option-muted[data-v-1c34f39a]{opacity:.4}", ""]);
// Exports
module.exports = exports;
